<template>
  <gh-invoke module="mes.business.mdl.structure.service" cls="StructureService" method="query_by_level" :args="args">
    <template v-slot="{args,data,loading}">
      <slot :args="args" :data="data" :loading="loading">
        <v-radio-group v-model="selected" row @change="change">
          <v-radio v-for="item in data" :key="item.Id" :value="item.Id" color="primary">
            <template v-slot:label>
              <div>
                <strong class="primary--text">{{item.Name}}({{item.ShortName}})</strong>
              </div>
            </template>
          </v-radio>
          <v-divider vertical></v-divider>
        </v-radio-group>
      </slot>

    </template>
  </gh-invoke>
</template>

<style scoped>

</style>

<script>
  import SiteComponent from "./siteComponent.ts";
  export default SiteComponent;
</script>